/**
 * Cosmesthetic — entry module
 *
 * Loaded as type="module", so it is deferred by default and runs after the
 * two GSAP classic scripts in document order. Each feature lives in its own
 * file and exposes a single init; nothing here touches the DOM directly.
 *
 * Relative imports resolve against this file's own CDN URL, which puts them
 * in the same /assets/ directory.
 */

import { initMotion } from './motion.js';
import { initNav } from './nav.js';
import { initColorMode } from './color-mode.js';
import { initCart } from './cart.js';
import { initProductForms } from './product-form.js';
import { initFitText } from './fit-text.js';
import { initParticleText } from './particle-text.js';

function boot() {
  initColorMode();
  initNav();
  initCart();
  initProductForms();
  initFitText();
  initParticleText();
  initMotion();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
